import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import Become from '@pages/become/ui/Become';

const schemaSearch = z.object({ usr: z.string().nonempty() });

export const Route = createFileRoute('/become')({
  validateSearch: schemaSearch,
  beforeLoad: async ({ search }) =>
    schemaSearch.parseAsync(search).catch(() => {
      throw redirect({ to: '/signin' });
    }),
  component: Become,
});
